<template>
    <div class="container"></div>
</template>


<script>
export default {
    name: "SearchResultP",
    setup() {
        return {};
    },
}
</script>

<style lang="scss" scoped>

</style>